// extracted by mini-css-extract-plugin
export default {"innerWrapper":"_t-z","tooltipWrapper":"au-z","icon":"bu-z","tooltip":"cu-z","content":"du-z"};